export const ADMIN_STORY_CARD_MODULES = [
  {
    key: 'story_cards',
    route: 'alumni',
    labelKey: 'admin.storyCards.alumni',
    type: 'alumni',
  },
  {
    key: 'story_cards',
    route: 'students',
    labelKey: 'admin.storyCards.students',
    type: 'students',
  },
  {
    key: 'story_cards',
    route: 'parents',
    labelKey: 'admin.storyCards.parents',
    type: 'parents',
  },
]

export const ADMIN_RECRUITMENT_MODULES = [
  {
    key: 'recruitment_applications',
    route: 'applications',
    labelKey: 'admin.recruitment.applications',
  },
  {
    key: 'recruitment_departments',
    route: 'departments',
    labelKey: 'admin.recruitment.departments',
  },
  {
    key: 'recruitment_statuses',
    route: 'statuses',
    labelKey: 'admin.recruitment.statuses',
  },
  {
    key: 'recruitment_settings',
    route: 'settings',
    labelKey: 'admin.recruitment.settings',
  },
]

export const ADMIN_RECRUITMENT_PERMISSION_GROUP = {
  labelKey: 'admin.nav.recruitment',
  children: ADMIN_RECRUITMENT_MODULES.map(({ key, labelKey }) => ({
    modules: [key],
    labelKey,
  })),
}

export const RECRUITMENT_MODULE_KEYS = ADMIN_RECRUITMENT_MODULES.map(({ key }) => key)

export const ADMIN_FORM_MODULES = [
  {
    key: 'forms_applications',
    route: 'applications',
    labelKey: 'admin.forms.applications',
    descriptionKey: 'admin.forms.applicationsDesc',
    icon: 'clipboard',
  },
  {
    key: 'forms_counseling',
    route: 'counseling',
    labelKey: 'admin.forms.counseling',
    descriptionKey: 'admin.forms.counselingDesc',
    icon: 'calendar',
  },
  {
    key: 'forms_contact',
    route: 'contact',
    labelKey: 'admin.forms.contact',
    descriptionKey: 'admin.forms.contactDesc',
    icon: 'mail',
  },
]

export const ADMIN_FORM_PERMISSION_GROUP = {
  labelKey: 'admin.nav.forms',
  children: ADMIN_FORM_MODULES.map(({ key, labelKey }) => ({
    modules: [key],
    labelKey,
  })),
}

export const ADMIN_PERMISSION_COLUMNS = [
  { modules: ['dashboard'], labelKey: 'admin.nav.dashboard' },
  { modules: ['menus'], labelKey: 'admin.nav.menus' },
  { modules: ['pages'], labelKey: 'admin.nav.pages' },
  { modules: ['hero_slider'], labelKey: 'admin.nav.heroSlider' },
  { modules: ['homepage'], labelKey: 'admin.nav.homepage' },
  { modules: ['news'], labelKey: 'admin.nav.news' },
  { modules: ['events'], labelKey: 'admin.nav.events' },
  { modules: ['story_cards'], labelKey: 'admin.nav.storyCards' },
  { modules: ['gallery'], labelKey: 'admin.nav.gallery' },
  { modules: ['ai_assistant'], labelKey: 'admin.nav.aiAssistant' },
  { modules: ['weekly_schedule'], labelKey: 'admin.nav.weeklySchedule' },
  { modules: ['settings'], labelKey: 'admin.nav.settings' },

  { modules: ['users'], labelKey: 'admin.nav.users' },
  { modules: ['activity_logs'], labelKey: 'admin.nav.activityLogs' },
]

export const FORM_MODULE_KEYS = ADMIN_FORM_MODULES.map(({ key }) => key)

export const ADMIN_NAV_MODULES = {
  dashboard: 'dashboard',
  pages: 'pages',
  homepage: 'homepage',
  hero_slider: 'hero_slider',
  story_cards: 'story_cards',
  news: 'news',
  events: 'events',
  gallery: 'gallery',
  menus: 'menus',
  recruitment_applications: 'recruitment_applications',
  recruitment_departments: 'recruitment_departments',
  recruitment_statuses: 'recruitment_statuses',
  recruitment_settings: 'recruitment_settings',
  forms_applications: 'forms_applications',
  forms_counseling: 'forms_counseling',
  forms_contact: 'forms_contact',
  ai_assistant: 'ai_assistant',
  weekly_schedule: 'weekly_schedule',
  settings: 'settings',
  users: 'users',
  activity_logs: 'activity_logs',
}
